import React, {useEffect, useRef, useState} from "react";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {isEmpty, validationChecker} from "../../../components/commonmethod/CommonMethod";
import {
    DetailFormPageShell,
    DetailListPage,
    DetailSummaryButton,
} from "../../../components/detailLayout";
import Th_title from "../../../components/Th_title";
import {getCodes} from "../../../api/code/CodeService";
import Section from "../../../components/section/Section";
import {RadioGroupBasic} from "../../../components/input/RadioGroupBasic";
import InputBasic from "../../../components/input/InputBasic";
import DrawerBasic from "../../../components/drawer/DrawerBasic";
import CompanyPageDrawer from "../../../components/drawer/CompanyPageDrawer";
import {
    getInspectionReportCode,
    updateInspectionReportCode
} from "../../../api/inspectionReportCode/InspectionReportCodeService";
import {skeleton} from "../../../redux/slice/apiSlice";
import {useDispatch} from "react-redux";
import {getBulletinboard, updateBulletinboard} from "../../../api/bulletinboard/BulletinboardService";
import ReadOnlyInputBasic from "../../../components/input/ReadOnlyInputBasic";
import FileUploader from "../../../components/files/FileUploader";
import UpdateFile from "../../../components/files/UpdateFile";
import TextAreaBasic from "../../../components/input/TextAreaBasic";

function BulletinboardUpdate(){
    const {id} = useParams();
    const dispatch = useDispatch();
    const [reportCode, setReportCode] = useState({});
    const [bulletinboardData, setBulletinboardData] = useState({});
    const [children, setChildren] = useState([]);
    const [code, setCode] = useState();
    const [returnAsObject, setReturnAsObject] = useState({});
    const [slideIn, setSlideIn] =useState(false);
    const [docs, setDocs] = useState([]);
    const location = useLocation();
    const navigate = useNavigate();
    const cancel={
        url:`/settings/bulletinboardlist/${bulletinboardData.gubun}`
    }

    useEffect(() => {
        if (!id) return;
        setBulletinboardData({});
        getBulletinboard(id).then((response) => {
            setBulletinboardData(response.data);
        }).finally(
            dispatch(skeleton(false))
        );
    }, [id, dispatch])

    const requireds =["subject"]
    const update = async ()=>{
        if(requireds.some(e=> isEmpty(bulletinboardData[e]))){
            alert("필수값이 누락되었습니다.")
            return
        }


        const {temp, createdAt, ...rest} = bulletinboardData


        const response = await updateBulletinboard(bulletinboardData);
        if(response.status === 200){
            alert("수정되었습니다.")
            navigate("/settings/bulletinboard/"+id, {
                state: {
                    test: location.state
                }
            });
        }
    }


    if(bulletinboardData) {
        return (
            <DetailFormPageShell
                className="common-container container-height-full border-l-gray detail-list-layout asset-detail-list-layout"
                title={bulletinboardData.gubun === "request" ? "요청자료실" : "자료실"}
                meta={bulletinboardData.gubun === "request" ? "서비스요청 > 요청자료실 > 수정" : "환경설정 > 알람관리 > 자료실 > 수정"}
                actions={
                    <>
                        <DetailSummaryButton muted onClick={() => navigate(cancel.url)}>
                            취소
                        </DetailSummaryButton>
                        <DetailSummaryButton
                            onClick={() => {
                                if (window.confirm("수정 하시겠습니까?")) {
                                    update();
                                }
                            }}
                        >
                            수정
                        </DetailSummaryButton>
                    </>
                }
            >
                <DetailListPage className="flex min-h-0 flex-1 flex-col">
                    <div className="container-height-body asset-detail-body detail-list-body flex min-h-0 flex-1 flex-col overflow-hidden">
                        <div className="asset-detail-list-scroll detail-list-scroll">
                <Section title={"기본정보"}>
                    <table className="w-full create-table">
                        <tbody>
                        <tr>
                            <Th_title title={"등록일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdAt"}
                                                    data={{data: bulletinboardData, setData: setBulletinboardData}}
                                                    value={bulletinboardData.createdAt}/>
                            </Th_title>
                            <Th_title title={"등록자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"createdBy"}
                                                    data={{data: bulletinboardData, setData: setBulletinboardData}}
                                                    value={bulletinboardData.createdBy}/>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"수정일시"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedAt"}
                                                    data={{data: bulletinboardData, setData: setBulletinboardData}}
                                                    value={bulletinboardData.updatedAt}/>
                            </Th_title>
                            <Th_title title={"수정자"} colspan={1} className="fieldset-td">
                                <ReadOnlyInputBasic target={"updatedBy"}
                                                    data={{data: bulletinboardData, setData: setBulletinboardData}}
                                                    value={bulletinboardData.updatedBy}/>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"제목"} colspan={3} className="fieldset-td" required={true}>
                                <InputBasic target={"subject"} data={{data: bulletinboardData, setData: setBulletinboardData}}/>
                            </Th_title>
                        </tr>
                        <tr>
                            <Th_title title={"내용"} colspan={3} className="fieldset-td">
                                <TextAreaBasic target={"content"} data={{data: bulletinboardData, setData: setBulletinboardData}}/>
                            </Th_title>
                        </tr>
                        </tbody>
                    </table>
                </Section>
                {/*파일 업로드*/}
                <Section title={"파일업로드"}>
                    <UpdateFile className={"update-image"} tableInfo={{tableName: "bulletinboard", joinKey: id}}/>
                </Section>
                        </div>
                    </div>
                </DetailListPage>
            </DetailFormPageShell>
        )

    }
}

export {BulletinboardUpdate}